import React, { memo, useContext } from 'react';
import { useFeatureFlag } from '@olx/react-laquesis';
import { onEnterOrSpace } from '../../../../commons/utils/keyEvents';
import TransactionContext from '../contexts/TransactionContext';
import Price from './Price';
import S from './style/AdTitle';

function AdTitle({ active, onTitleClick, isSeller }) {
  const transaction = useContext(TransactionContext);

  const { ad } = transaction || {};
  const isOverViewPriceDisplayOn = !!useFeatureFlag('psm-574');
  const shouldDisplayPrice = isOverViewPriceDisplayOn && isSeller;

  return (
    <S.Info transaction={transaction} data-testid="ad-info">
      {transaction && (
        <>
          <S.InfoTitle active={active}>
            {active ? (
              <S.InfoTitleAnchor data-cy="ad-title" data-testid="ad-title" href={ad?.url}>
                {ad?.title}
              </S.InfoTitleAnchor>
            ) : (
              <>
                <S.InfoTitleLink
                  data-cy="ad-title"
                  data-testid="ad-title"
                  tabIndex={0}
                  role="link"
                  onKeyUp={onEnterOrSpace(onTitleClick)}
                  onClick={onTitleClick}
                >
                  {ad?.title}
                </S.InfoTitleLink>
                <S.InfoTitleIcon data-cy="ad-title-arrow" onClick={onTitleClick} active={active}>
                  <S.ArrowRightIcon />
                </S.InfoTitleIcon>
              </>
            )}
          </S.InfoTitle>
          {shouldDisplayPrice && <Price prices={transaction.order.price} />}
        </>
      )}
    </S.Info>
  );
}

export default memo(AdTitle);
